module.exports = __webpack_public_path__ + "img/edit.1e0cb82d.svg";